<script>
import Vue from 'vue'
import api from '../api'
import swal from 'sweetalert'
import form from '../mixins/form'

export default {

  mixins: [form],

  data () {
    return {
      form: {},
      roles: ['admin', 'retoucher', 'client']
    }
  }

}
</script>

<template>
  <form @submit.prevent="submit">

    <div class="field">
      <label class="label">Role</label>
      <p class="control">
        <span class="select">
          <select v-model="form.role" required>
            <option value="" />
            <option v-for="role in roles" :value="role">
              {{ role }}
            </option>
          </select>
        </span>
      </p>
      <p v-show="errors.has('role')" class="help is-danger">{{ errors.first('role') }}</p>
    </div>
    
    <div class="field">
      <label class="label">Email</label>
      <p class="control">
        <input v-model="form.email" name="email" v-validate="'required|email'" required class="input" type="text" placeholder="Email">
      </p>
      <p v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</p>
    </div>

    <div class="field">
      <label class="label">Password</label>
      <p class="control">
        <input v-model="form.password" name="password" class="input" type="password">
      </p>
      <p class="help">If editing, leave empty</p>
      <p v-show="errors.has('password')" class="help is-danger">{{ errors.first('password') }}</p>
    </div>

    <div class="field">
      <label class="label">Extra Emails</label>
      <p class="control">
        <textarea rows="10" v-model="form.extra_emails" name="email" class="textarea" placeholder="One email per line"></textarea>
      </p>
    </div>

    <div class="field is-grouped">
      <p class="control">
        <button class="button is-primary" :class="{ 'is-loading': loading }">Submit</button>
      </p>
      <p class="control">
        <router-link to="/users" class="button is-link">Cancel</router-link>
      </p>
    </div>
  
  </form>
</template>